import { createClasses } from '../../theme/createClasses';

// ----------------------------------------------------------------------

export const iconifyClasses = {
  root: createClasses('iconify__root'),
};
